import { createFileRoute } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/LegalPage";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: "Termos de Uso — Projeto 101 · 101 Negócios Reais" },
      {
        name: "description",
        content:
          "Termos de Uso do produto digital 101 Negócios Reais: acesso, uso permitido, propriedade intelectual, garantia e suspensão de acesso.",
      },
      { property: "og:title", content: "Termos de Uso — Projeto 101" },
      { property: "og:description", content: "Termos que regem o uso do 101 Negócios Reais." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TermosPage,
});

function TermosPage() {
  return (
    <LegalPage
      title="Termos de Uso"
      updatedAt="22 de julho de 2026"
      intro="Bem-vindo ao Projeto 101. Ao adquirir ou utilizar o produto digital 101 Negócios Reais, você concorda integralmente com os presentes Termos de Uso."
    >
      <LegalSection n={1} title="Objeto">
        <p>O Projeto 101 disponibiliza acesso a uma plataforma online composta por:</p>
        <LegalList
          items={[
            <>Plataforma <em>“101 Negócios Reais”</em> com as 101 fichas de negócios;</>,
            "Bônus e ferramentas digitais;",
            "Área de membros online;",
            "Atualizações eventualmente disponibilizadas;",
            "Conteúdos complementares.",
          ]}
        />
        <p>O acesso é pessoal, individual e intransferível.</p>
      </LegalSection>

      <LegalSection n={2} title="Acesso">
        <p>Após a confirmação do pagamento:</p>
        <LegalList
          items={[
            "será criada uma conta em nosso sistema;",
            "o usuário receberá um e-mail para definição da senha;",
            "o acesso será liberado automaticamente.",
          ]}
        />
        <p>É responsabilidade do comprador manter seus dados atualizados.</p>
      </LegalSection>

      <LegalSection n={3} title="Uso permitido">
        <p>É permitido utilizar o conteúdo exclusivamente para fins pessoais ou profissionais próprios.</p>
        <p>É proibido:</p>
        <LegalList
          items={[
            "compartilhar login;",
            "vender o conteúdo;",
            "distribuir arquivos;",
            "copiar integralmente o material;",
            "disponibilizar downloads em grupos ou sites;",
            "comercializar qualquer parte do conteúdo sem autorização.",
          ]}
        />
      </LegalSection>

      <LegalSection n={4} title="Propriedade intelectual">
        <p>Todo o conteúdo pertence exclusivamente ao Projeto 101.</p>
        <p>Todo material é protegido pela Lei de Direitos Autorais (Lei nº 9.610/98).</p>
        <p>O uso indevido poderá gerar responsabilização civil e criminal.</p>
      </LegalSection>

      <LegalSection n={5} title="Garantia">
        <p>
          O comprador possui garantia de 7 dias, conforme o Código de Defesa do Consumidor, para
          solicitar o cancelamento da compra.
        </p>
        <p>Após esse período, não haverá reembolso, salvo previsão legal.</p>
      </LegalSection>

      <LegalSection n={6} title="Atualizações">
        <p>
          Atualizações poderão ser disponibilizadas sem custo adicional durante a vigência do
          produto, a exclusivo critério do Projeto 101.
        </p>
      </LegalSection>

      <LegalSection n={7} title="Limitação de responsabilidade">
        <p>Os conteúdos possuem finalidade educacional.</p>
        <p>
          Os resultados obtidos dependerão da dedicação, experiência e aplicação prática de cada
          usuário.
        </p>
        <p>Não garantimos faturamento, lucro ou qualquer resultado financeiro específico.</p>
      </LegalSection>

      <LegalSection n={8} title="Suspensão de acesso">
        <p>O acesso poderá ser suspenso ou cancelado em caso de:</p>
        <LegalList
          items={[
            "fraude;",
            "tentativa de invasão;",
            "compartilhamento de login;",
            "violação destes Termos;",
            "chargeback ou cancelamento da compra.",
          ]}
        />
      </LegalSection>

      <LegalSection n={9} title="Alterações">
        <p>Os presentes Termos poderão ser atualizados periodicamente.</p>
        <p>A versão mais recente permanecerá disponível nesta página.</p>
      </LegalSection>

      <LegalSection n={10} title="Contato">
        <p>
          E-mail:{" "}
          <a href="mailto:suporte@101negocios.com.br" className="underline text-[#1E7A5C]">
            suporte@101negocios.com.br
          </a>
        </p>
      </LegalSection>
    </LegalPage>
  );
}
